module.exports = __webpack_public_path__ + "img/ao.3cceba75.svg";